import {Injectable} from "@angular/core";
import {PdfCatalogRepo} from "@app/core/pdf-catalog/domain/repositories/pdf-catalog.repo";

/**
 * Use case for removing a specific product the user has added to the PDF catalog.
 */
@Injectable({
    providedIn: "root",
})

export class RemovePdfCatalogProductUseCase {

    constructor(private pdfCatalogLocal: PdfCatalogRepo) {
    }

    execute(productCode: string): void {
        this.pdfCatalogLocal.removeProduct(productCode);
    }
}
